import { Tab } from "@headlessui/react";
import * as React from "react";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";

import { LibrarySetting } from "./library-setting";
import { VideoURLSetting } from "./url-setting";

/**
 * Classic tab shell only (Library / URL + advanced mute). Recording metadata is composed
 * in `video-settings.tsx`, not here — keep this file free of v2-only UI.
 */
export function VideoSettingsLegacy() {
  const { t } = useTranslation();

  return (
    <Tab.Group as="div" className="relative">
      <Tab.List className="flex h-12 w-full items-center justify-center text-sm">
        <Tab className="h-full flex-1 cursor-pointer border-solid font-medium focus:outline-none ui-selected:border-b-2 ui-selected:border-primary ui-selected:text-gray-800 ui-not-selected:border-b ui-not-selected:border-gray-300 ui-not-selected:text-gray-650">
          {t("preference-panel.library")}
        </Tab>
        <Tab className="h-full flex-1 cursor-pointer border-solid font-medium focus:outline-none ui-selected:border-b-2 ui-selected:border-primary ui-selected:text-gray-800 ui-not-selected:border-b ui-not-selected:border-gray-300 ui-not-selected:text-gray-650">
          {t("preference-panel.url")}
        </Tab>
      </Tab.List>
      <Tab.Panels as={Fragment}>
        <Tab.Panel as={Fragment}>
          <LibrarySetting />
        </Tab.Panel>
        <Tab.Panel>
          <VideoURLSetting />
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
}
